(function () {
  // -------------------------------
  // Helpers de fecha
  // -------------------------------
  function parseStartDate(dateStr) {
    if (!dateStr) return null;
    const parts = dateStr.split("-");
    if (parts.length !== 3) return null;
    const y = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    const d = parseInt(parts[2], 10);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }

  function atMidnight(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addDays(date, n) {
    const d = new Date(date);
    d.setDate(d.getDate() + n);
    return d;
  }

  // -------------------------------
  // Inicializar una sección advent
  // -------------------------------
  function initSection(sectionEl) {
    const startDate = parseStartDate(sectionEl.dataset.startDate);
    if (!startDate) return;

    const today = atMidnight(new Date());
    const sectionId = sectionEl.dataset.sectionId || "";
    const cards = Array.from(sectionEl.querySelectorAll(".advent-card"));

    const modal = sectionEl.querySelector(".advent-modal");
    if (!modal) return;

    const modalImg = modal.querySelector(".advent-modal__img");
    const modalLink = modal.querySelector(".advent-modal__link");

    // prefix para localStorage (por sección, por si hay más de un calendario)
    const keyPrefix = sectionId ? "advent_" + sectionId + "_" : "advent_";
    const storageKeyForDay = (day) => keyPrefix + "opened_day_" + day;

    // ---------------------------
    // Handler global del link del modal
    // ---------------------------
    if (modalLink) {
      modalLink.addEventListener("click", function (e) {
        // Si es día pasado o está marcado como no-click, nunca navegamos
        if (this.dataset.isPast === "true" || this.classList.contains("no-click")) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    }

    // ---------------------------
    // Abrir modal desde una card
    // ---------------------------
    function openModalFromCard(card) {
      if (!modal || !modalImg || !modalLink) return;

      const popupImage = card.dataset.popupImage;
      const day = card.dataset.day;
      const ctaLink = card.dataset.ctaLink;
      const isPast = card.classList.contains("is-past");

      // Marcar como abierto (solo si tiene day)
      if (day) {
        localStorage.setItem(storageKeyForDay(day), "true");
        card.classList.add("is-openable");
      }

      // Imagen del popup
      if (popupImage) {
        modalImg.src = popupImage;
        modalImg.alt = "";
      } else {
        modalImg.removeAttribute("src");
        modalImg.alt = "";
      }

      // Lógica del link:
      // - Días pasados => sin navegación (no-click)
      // - Día de hoy con link => navegación activa
      // - Sin link configurado => no-click
      modalLink.dataset.isPast = isPast ? "true" : "false";

      if (isPast || !ctaLink) {
        // día pasado o sin link → deshabilitar navegación
        modalLink.href = "javascript:void(0)";
        modalLink.classList.add("no-click");
      } else {
        // día actual con link → permitir navegación
        modalLink.href = ctaLink;
        modalLink.classList.remove("no-click");
      }

      modal.classList.add("is-active");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }

    // ---------------------------
    // Cerrar modal
    // ---------------------------
    function closeModal() {
      modal.classList.remove("is-active");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    modal.addEventListener("click", (e) => {
      if (e.target.matches("[data-modal-close]")) {
        closeModal();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    });

    // ---------------------------
    // Estado de cada día
    // ---------------------------
    cards.forEach((card) => {
      const day = parseInt(card.dataset.day, 10);
      if (!day) return;

      // Day 1 = start_date, Day N = start_date + (N-1)
      const openDate = atMidnight(addDays(startDate, day - 1));

      const isFuture = today < openDate;
      const isPast = today > openDate;
      const isToday = today.getTime() === openDate.getTime();

      const wasOpened = localStorage.getItem(storageKeyForDay(day)) === "true";

      if (isFuture) {
        // Día futuro: bloqueado, no abre
        card.classList.add("is-locked");
        card.setAttribute("aria-expanded", "false");
      } else {
        // Hoy o pasado
        card.setAttribute("aria-expanded", "true");

        if (isPast) {
          // Días pasados siempre abiertos y marcados como "past"
          card.classList.add("is-openable", "is-past");
          localStorage.setItem(storageKeyForDay(day), "true");
        }

        if (isToday) {
          card.classList.add("is-today");
          if (wasOpened) {
            // Si ya lo abrió antes en este navegador, mostrar como abierto
            card.classList.add("is-openable");
          }
          // Si NO lo ha abierto:
          // - no tiene is-openable (se ve cerrado)
          // - pero tampoco is-locked (sí responde al click)
        }
      }

      card.addEventListener("click", () => {
        // Solo bloqueamos clics en días futuros
        if (card.classList.contains("is-locked")) return;
        openModalFromCard(card);
      });
    });
  }

  // -------------------------------
  // Init global
  // -------------------------------
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(".advent[data-start-date]")
      .forEach(initSection);
  });
})();
